import { Box } from '@mui/material';
import { useContext } from 'react';
import { SlidePreviewContext } from '../../lessons/contexts/SlidePreviewContext';
import { SlideComponent, SlideComponentSasFillInTheBlanksWriting } from 'models/lesson/LessonModel';

export const SlideSasFillInTheBlanksWriting = ({ item }: { item: SlideComponent; index: number }) => {
    const { zoom } = useContext(SlidePreviewContext);

    let itemContent: SlideComponentSasFillInTheBlanksWriting = item.content as SlideComponentSasFillInTheBlanksWriting;

    // console.log(item.pos.x * zoom, item.pos.y * zoom);

    return (
        <Box
            component='img'
            src={itemContent.imageURL && itemContent.imageURL !== '' ? itemContent.imageURL : `/characters/${itemContent.image !== '' ? itemContent.image + '/image.png' : 'default.png'}`}
            alt='bg'
            sx={{
                position: 'absolute',
                zoom: zoom,
                aspectRatio: 'auto',
                transform: `scaleX(${itemContent.flip ?? 1})`,
                pointerEvents: 'none',
                left: item.pos.x,
                top: item.pos.y,
                zIndex: itemContent.zIndex,
                m: 'inherit',
                p: 'inherit',
            }}
            width={item.size.width}
        />
    );
};
